module.exports = __webpack_public_path__ + "img/return.36294e0d.svg";